(function () {
  // This file is now loaded once per page from snippets/product-card-assets.liquid.
  // It used to be emitted once per product card, which meant the IIFE ran 60-100x and
  // attached that many duplicate document-level click listeners. This guard makes a
  // repeat include a no-op, so any layout that ends up including it twice stays correct.
  if (window.InspiredGoProductCardMacros && window.InspiredGoProductCardMacros.__initialized) return;

  function collectNutritionEntries(source, bucket) {
    if (!source) return bucket;

    if (Array.isArray(source)) {
      source.forEach(function (item) {
        collectNutritionEntries(item, bucket);
      });
      return bucket;
    }

    if (typeof source === 'object') {
      if (source.title && source.description) {
        bucket.push({ title: source.title.toString(), description: source.description.toString() });
      }
      if (source.label && source.value) {
        bucket.push({ title: source.label.toString(), description: source.value.toString() });
      }
      if (source.name && source.value) {
        bucket.push({ title: source.name.toString(), description: source.value.toString() });
      }
      Object.keys(source).forEach(function (key) {
        collectNutritionEntries(source[key], bucket);
      });
    }

    return bucket;
  }

  function getNutritionValue(entries, keywords) {
    for (var i = 0; i < entries.length; i++) {
      var title = entries[i].title.toLowerCase();
      if (keywords.some(function (kw) { return title.indexOf(kw) !== -1; })) {
        return entries[i].description;
      }
    }
    return '';
  }

  function normalizeStatValue(value, label) {
    if (!value) return '';
    var cleaned = value.toString().trim();
    if (!cleaned) return '';

    if (label === 'Calories') {
      var calorieMatch = cleaned.match(/\d+/);
      return calorieMatch ? calorieMatch[0] : cleaned;
    }

    if (label === 'Protein' || label === 'Carbs' || label === 'Fibre') {
      var gramMatch = cleaned.match(/\d+(\.\d+)?\s*g/i);
      if (gramMatch) return gramMatch[0].replace(/\s+/g, '');
      var numberMatch = cleaned.match(/\d+(\.\d+)?/);
      if (numberMatch) return numberMatch[0] + 'g';
    }

    return cleaned;
  }

  function normalizeStatLabel(label) {
    var normalized = String(label || '').toLowerCase();
    if (normalized.indexOf('protein') !== -1) return 'Protein';
    if (normalized.indexOf('calor') !== -1) return 'Calories';
    if (normalized.indexOf('carb') !== -1) return 'Carbs';
    if (normalized.indexOf('fat') !== -1) return 'Fat';
    if (normalized.indexOf('fibre') !== -1 || normalized.indexOf('fiber') !== -1) return 'Fibre';
    return '';
  }

  function getStatValuesFromNutrition(nutritionDetails) {
    var statsMap = { Protein: '', Calories: '', Carbs: '', Fibre: '' };
    if (!nutritionDetails) return statsMap;

    if (nutritionDetails.main && Array.isArray(nutritionDetails.main) && nutritionDetails.main.length >= 3) {
      nutritionDetails.main.forEach(function (entry) {
        var primaryLabel = normalizeStatLabel(entry && (entry.description || entry.label || ''));
        var primaryValue = normalizeStatValue(entry && (entry.title || entry.value || ''), primaryLabel);
        if (primaryLabel && primaryValue && statsMap.hasOwnProperty(primaryLabel) && !statsMap[primaryLabel]) {
          statsMap[primaryLabel] = primaryValue;
        }

        var secondaryLabel = normalizeStatLabel(entry && (entry.title || ''));
        var secondaryValue = normalizeStatValue(entry && (entry.description || entry.value || ''), secondaryLabel);
        if (secondaryLabel && secondaryValue && statsMap.hasOwnProperty(secondaryLabel) && !statsMap[secondaryLabel]) {
          statsMap[secondaryLabel] = secondaryValue;
        }
      });
    }

    if (nutritionDetails.rest && Array.isArray(nutritionDetails.rest)) {
      nutritionDetails.rest.forEach(function (entry) {
        var label = normalizeStatLabel(entry && (entry.title || entry.description || entry.label || ''));
        var value = normalizeStatValue(entry && (entry.grams || entry.value || entry.description || ''), label);
        if (label && value && statsMap.hasOwnProperty(label) && !statsMap[label]) {
          statsMap[label] = value;
        }
      });
    }

    var entries = collectNutritionEntries(nutritionDetails, []);
    ['Protein', 'Calories', 'Carbs', 'Fibre'].forEach(function (label) {
      if (statsMap[label]) return;
      var fallbackKeywords = {
        Protein: ['protein'],
        Calories: ['calorie'],
        Carbs: ['carb'],
        Fibre: ['fibre', 'fiber']
      };
      statsMap[label] = normalizeStatValue(getNutritionValue(entries, fallbackKeywords[label]), label);
    });

    return statsMap;
  }

  // Extract numeric value from a stat string like "30g" or "560"
  function extractNumber(statValue) {
    if (!statValue) return 0;
    var match = statValue.toString().match(/(\d+(\.\d+)?)/);
    return match ? parseFloat(match[1]) : 0;
  }

  // Format a combined value back with unit
  function formatStat(value, label) {
    var rounded = Math.round(value);
    if (label === 'Calories') return rounded.toString();
    return rounded + 'g';
  }

  // Sum base stats + protein stats
  function combineMacros(baseStats, proteinStats) {
    var combined = {};
    ['Protein', 'Calories', 'Carbs', 'Fibre'].forEach(function (label) {
      var baseNum = extractNumber(baseStats[label]);
      var proteinNum = extractNumber(proteinStats[label]);
      combined[label] = formatStat(baseNum + proteinNum, label);
    });
    return combined;
  }

  // Parse nutrition JSON safely
  function parseNutritionData(raw) {
    if (!raw) return null;
    try {
      var parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
      return parsed;
    } catch (e) {
      return null;
    }
  }

  // Update macros row display — hides individual macros with no data
  function updateMacrosRow(macrosRow, stats) {
    var visibleCount = 0;
    ['protein', 'calories', 'fibre'].forEach(function (key) {
      var el = macrosRow.querySelector('[data-macro="' + key + '"]');
      if (!el) return;
      var label = key.charAt(0).toUpperCase() + key.slice(1);
      var value = stats[label] || '';
      var macroDiv = el.closest('.card-macro');
      if (value) {
        el.textContent = value;
        if (macroDiv) macroDiv.style.display = '';
        visibleCount++;
      } else {
        if (macroDiv) macroDiv.style.display = 'none';
      }
    });

    if (visibleCount > 0) {
      macrosRow.removeAttribute('hidden');
      macrosRow.style.gridTemplateColumns = 'repeat(' + visibleCount + ', 1fr)';
    } else {
      macrosRow.setAttribute('hidden', '');
    }
  }

  // Get base nutrition stats for a card (cached on the macros row element)
  function getBaseStats(card) {
    var macrosRow = card.querySelector('.card-macros-row');
    if (!macrosRow) return null;

    // Return cached if available
    if (macrosRow._baseStats) return macrosRow._baseStats;

    var jsonScript = card.querySelector('script.product-card-modal-data');
    if (!jsonScript) return null;

    try {
      var data = JSON.parse(jsonScript.textContent);
      var nutritionalObject = parseNutritionData(data.nutritionalObject);
      if (!nutritionalObject) return null;

      var stats = getStatValuesFromNutrition(nutritionalObject);
      macrosRow._baseStats = stats;
      return stats;
    } catch (e) {
      return null;
    }
  }

  function populateCardMacros() {
    var cards = document.querySelectorAll('.card-wrapper');
    cards.forEach(function (card) {
      var macrosRow = card.querySelector('.card-macros-row');
      if (!macrosRow) return;

      var baseStats = getBaseStats(card);
      if (!baseStats) {
        macrosRow.setAttribute('hidden', '');
        return;
      }

      // Check if a protein pill is already selected (non-salad-only)
      var selectedPill = card.querySelector('.protein-pill.selected');
      if (selectedPill && selectedPill.dataset.value && selectedPill.dataset.proteinNutrition) {
        var proteinNutrition = parseNutritionData(selectedPill.dataset.proteinNutrition);
        if (proteinNutrition) {
          var proteinStats = getStatValuesFromNutrition(proteinNutrition);
          updateMacrosRow(macrosRow, combineMacros(baseStats, proteinStats));
          return;
        }
      }

      // Default: show base stats only
      updateMacrosRow(macrosRow, baseStats);
    });
  }

  window.InspiredGoProductCardMacros = window.InspiredGoProductCardMacros || {};
  window.InspiredGoProductCardMacros.refresh = populateCardMacros;
  window.InspiredGoProductCardMacros.__initialized = true;

  // Listen for protein pill clicks to update macros
  document.addEventListener('click', function (event) {
    var pill = event.target.closest('.protein-pill');
    if (!pill) return;

    var card = pill.closest('.card-wrapper');
    if (!card) return;

    var macrosRow = card.querySelector('.card-macros-row');
    if (!macrosRow) return;

    var baseStats = getBaseStats(card);
    if (!baseStats) return;

    // If "Salad Only" (no value) or no nutrition data on pill, show base stats
    if (!pill.dataset.value || !pill.dataset.proteinNutrition) {
      updateMacrosRow(macrosRow, baseStats);
      return;
    }

    // Parse protein product nutrition and combine
    var proteinNutrition = parseNutritionData(pill.dataset.proteinNutrition);
    if (proteinNutrition) {
      var proteinStats = getStatValuesFromNutrition(proteinNutrition);
      updateMacrosRow(macrosRow, combineMacros(baseStats, proteinStats));
    } else {
      updateMacrosRow(macrosRow, baseStats);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', populateCardMacros);
  } else {
    populateCardMacros();
  }

  document.addEventListener('inspiredgo:product-cards-rendered', populateCardMacros);
})();
